// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/icons/utility/compass_base.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/icons/utility/arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Zen+Dots&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer theme, base, components, utilities;
@layer theme {
  .grey,
  .cream {
    color: #5a1aa8;
  }
  .cream-95 {
    color: #085fc3;
  }
  .blue {
    color: rgb(252, 216, 73);
  }
  .error-color {
    color: #911915;
  }
}
@layer base {
  :root {
    line-height: 1.5;
  }
  h1 {
    margin: 0;
    white-space: nowrap;
  }
  h2,
  h3,
  h4,
  h5,
  ol,
  ul,
  figure,
  p,
  body {
    margin: 0;
  }
  ol[role="list"],
  ul[role="list"] {
    list-style: none;
    padding-inline: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  div,
  a,
  label,
  button,
  input {
    font-family: "Zen Dots", Inter, system-ui, "Segoe UI", Roboto, Helvetica,
      Arial, sans-serif;
  }
  h1 {
    white-space: nowrap;
  }
  p {
    font-family: "Zen Dots", Inter, system-ui, "Segoe UI", Roboto, Helvetica, Arial,
      sans-serif;
  }
  button {
    border-style: none;
    border-radius: 0.4rem;
    padding: 0.3rem 1rem;
    background-color: rgba(66, 172, 248, 0.444);
  }
  html {
    width: 100vw;
    height: 100vh;
    background-color: #0c0706dd;
  }
  body {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: fit-content;
    overflow-x: auto;
  }
  footer {
  color: white;
  }
  /* card styling */
  .card-square-small {
    width: 48px;
    height: 48px;
  }
  .card-square-med {
    width: 64px;
    height: 64px;
  }
  .card-square-large {
    width: 400px;
    height: 400px;
  }
  .card-rect-hor-large {
    width: 500px;
    height: 180px;
  }
  /* icon styling */
  .icon-div-small {
    width: 26px;
    height: 26px;
  }
  .icon-div-med {
    width: 40px;
    height: 40px;
  }
  .icon-div-lg {
    width: 105px;
    height: 105px;
  }
  .icon-div-2xl {
    width: 128px;
    height: 128px;
  }
  .icon {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  /* Background Video's Styling */
  #background-vid {
    position: fixed;
    right: 0;
    bottom: 0;
    object-fit: cover;
    min-width: 100%;
    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    z-index: -5;
    opacity: 0.75;
  }
  header {
    box-sizing: border-box;
    margin: 1.5rem 5%;
    margin-bottom: 7rem;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    min-width: 500px;
  }
  /* Searchbar's Styling */
  #searchbar {
    flex: 1 0 510px;
    width: 540px;
    padding: 0.4rem 0.6rem;
    margin-bottom: 0.6rem;
  }
  #location-input {
    flex: 1;
    padding: 0rem 0.5rem;
    font-size: var(--text-sm);
    color: #fff7e0;
  }
  #location-input::placeholder {
    color: #fff7e092;
  }
  #content {
    margin: 0rem 5%;
    margin-top: 4rem;
    padding-bottom: 1rem;
    width: 960px;
    display: grid;
    grid-template-rows: repeat(5, 215px);
    grid-template-columns: repeat(4, 1fr);
    column-gap: 2rem;
    row-gap: 2rem;
  }
  #curr-data {
    max-width: 900px;
    min-width: 500px;
    grid-column: 1 / 5;
    grid-row: 1 / 2;
  }
  #curr-temp {
    min-width: 300px;
  }
  #days-data {
    grid-column: 1 / 3;
    grid-row: 3 / 6;
  }
  #day-data-cards {
    flex: auto;
  }
  #hours-data {
    backdrop-filter: blur(25px);
    background-color: rgba(84, 159, 206, 0.167); 
    border-radius: 0.4rem;
    border-radius: 0.4rem;
    padding: 0.5rem 1rem;
    grid-column: 1 / 5;
    grid-row: 2 / 3;
  }
  #hours-data-cards::-webkit-scrollbar {
    height: 12px;
  }
  #hours-data-cards::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }
  #hours-data-cards::-webkit-scrollbar-thumb {
    background: #2572ca;
    border-radius: 6px;
  }
  #hours-data-cards::-webkit-scrollbar-button {
    background: #2572ca;
    width: 12px;
    height: 12px;
  }
  #curr-humidity-data {
    grid-column: 3 / 4;
    grid-row: 3 / 4;
  }
  #curr-precipitation-data {
    grid-column: 4 / 5;
    grid-row: 3 / 4;
  }
  #curr-wind-data {
    grid-column: 3 / 5;
    grid-row: 4 / 5;
  }
  #curr-uv-data {
    grid-column: 3 / 4;
    grid-row: 5 / 6;
  }
  #curr-pressure-data {
    grid-column: 4 / 5;
    grid-row: 5 / 6;
  }
  #compass {
    position: relative;
  }
  #compass-base {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-size: cover;
    width: 140px;
    height: 140px;
    filter: invert(20%) sepia(100%) saturate(10000%) hue-rotate(35deg) brightness(100%) contrast(100%);
  }
  #compass-needle {
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-size: cover;
    width: 140px;
    height: 140px;
    filter: invert(20%) sepia(100%) saturate(10000%) hue-rotate(35deg) brightness(100%) contrast(100%);
  }
}
@layer components {
  .weather-card {
    backdrop-filter: blur(25px);
    background-color: rgba(84, 159, 206, 0.167); 
    border-radius: 1rem;
    padding: 0.5rem 1rem;
    padding-bottom: 1rem;
  }
  .hour-component {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 124px;
    margin: 0.8rem;
  }
  .day-component {
    margin: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .temp-bar {
    position: relative;
    flex: initial;
    height: 0.5rem;
    min-width: 130px;
    background-color: #6e6e6e65;
    border-radius: 0.2rem;
  }
  .temp-bar > .bar {
    position: absolute;
    z-index: 2;
    left: 0;
    width: 100%;
    border-radius: 1rem;
    height: 100%;
    background-image: linear-gradient(to right, #5ef11f, #fdde29);
  }
  .wind-text-wrapper {
    display: flex;
    justify-content: space-between;
  }
}
@layer utilities {
  .width-42px {
    width: 42px;
  }
  .width-55px {
    width: 55px;
  }
  /* SVG's Styling */
  .cream-svg {
    filter: invert(89%) sepia(5%) saturate(800%) hue-rotate(365deg)
      brightness(120%) contrast(95%);
  }
  .red-svg {
    filter: invert(35%) sepia(100%) saturate(2500%) hue-rotate(0deg) brightness(100%) contrast(100%);
  }
  /* Background's Styling */
  .no-background {
    background: none;
  }
  .background-frosted {
    backdrop-filter: blur(15px);
    background-color: rgba(240, 240, 240, 0.15);
  }
  .background-frosted-grey {
    backdrop-filter: blur(25px);
    background-color: rgba(65, 65, 65, 0.359);
  }
  /* Overflow Behaviour */
  .overflow-x-scroll {
    overflow-x: scroll;
  }
  .overflow-y-scroll {
    overflow-y: scroll;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  /* border styling */
  .border-rounded {
    border-radius: 0.8rem;
  }
  .border-white-outline {
    border-style: solid;
    border-width: 0.8px;
    border-color: rgba(255, 255, 255, 0.391);
  }
  .no-border {
    border-style: none;
  }
  /* display styling */
  .width-60pc {
    width: 60%;
  }
  .height-36px {
    height: 36px;
  }
  .height-80px {
    height: 80px;
  }
  .grid {
    display: grid;
  }
  .flex {
    display: flex;
  }
  .flex-col {
    display: flex;
    flex-direction: column;
  }
  .flex-auto {
    flex: auto;
  }
  .inline-block {
    display: inline-block;
  }
  .hidden {
    display: none;
  }
  .justify-center {
    justify-content: center;
  }
  .space-btw {
    justify-content: space-between;
  }
  .space-evenly {
    justify-content: space-evenly;
  }
  .align-start {
    align-items: flex-start;
  }
  .align-center {
    align-items: center;
  }
  .align-bottom {
    align-items: end;
  }
  .gap-0p2 {
    gap: 0.2rem;
  }
  .gap-0p4 {
    gap: 0.4rem;
  }
  .gap-0p6 {
    gap: 0.6rem;
  }
  .gap-1p5 {
    gap: 1.5rem;
  }
  .gap-1 {
    gap: 1rem;
  }
  .gap-2 {
    gap: 2rem;
  }
  .gap-4 {
    gap: 4rem;
  }
  /* Box's Styling */
  .margin-tb-1 {
    margin: 1rem 0rem;
  }
  .margin-right-auto {
    margin-right: auto;
  }
  .margin-left-auto {
    margin-left: auto;
  }
  .margin-top-auto {
    margin-top: auto;
  }
  .margin-bot-auto {
    margin-bottom: auto;
  }
  .margin-left-3 {
    margin-left: 3rem;
  }
  .margin-left-05 {
    margin-left: 0.5rem;
  }
  .margin-bot-1p2 {
    margin-bottom: 1.2rem;
  }
  .margin-bot-2 {
    margin-bottom: 2rem;
  }
  .margin-bot-12 {
    margin-bottom: 12rem;
  }
  .padding-2 {
    padding: 2rem;
  }
  .padding-bot-0p2 {
    padding-bottom: 0.2rem;
  }
  .border-bot-outline {
    border-bottom: 0.8px solid #fff9e895;
  }
  /* Pseudoclass Styling */
  .no-focus:focus {
    border-style: none;
    outline: none;
  }
  /* Text Styling */
  .text-center {
    text-align: center;
  }
  .text-sm {
    font-size: 0.9rem;
  }
  .text-base {
    font-size: 1rem;
  }
  .text-med {
    font-size: 1.25rem;
  }
  .text-lg {
    font-size: 1.5rem;
  }
  .text-2xl {
    font-size: 2rem;
  }
  .text-3xl {
    font-size: 3rem;
  }
  .text-4xl {
    font-size: 4rem;
  }
  .text-5xl {
    font-size: 5rem;
  }
  .text-6xl {
    font-size: 6rem;
  }
  .text-8xl {
    font-size: 8rem;
  }
  .weight-light {
    font-weight: 200;
  }
  .weight-normal {
    font-weight: 300;
  }
  .weight-med {
    font-weight: 500;
  }
  .weight-semibold {
    font-weight: 600;
  }
  .weight-bold {
    font-weight: 700;
  }
  .letter-space-05 {
    letter-spacing: -0.5px;
  }
  .line-height-1 {
    line-height: 1;
  }
  .line-height-1p2 {
    line-height: 1.2;
  }
  .line-height-1p5 {
    line-height: 1.5;
  }
  .line-height-2 {
    line-height: 2;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AACA,yCAAyC;AACzC;EACE;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,mBAAmB;EACrB;EACA;;;;;;;;;IASE,SAAS;EACX;EACA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;;;;;;;;;;IAUE;uBACmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE;gBACY;EACd;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,2CAA2C;EAC7C;EACA;IACE,YAAY;IACZ,aAAa;IACb,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;EAClB;EACA;EACA,YAAY;EACZ;EACA,iBAAiB;EACjB;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA,iBAAiB;EACjB;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;EACA,+BAA+B;EAC/B;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;EACA,wBAAwB;EACxB;IACE,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,OAAO;IACP,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,2CAA2C;IAC3C,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,oCAAoC;EACtC;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,yDAAiE;IACjE,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kGAAkG;EACpG;EACA;IACE,kBAAkB;IAClB,yDAA0D;IAC1D,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kGAAkG;EACpG;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,cAAc;EAChB;EACA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,6DAA6D;EAC/D;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA,kBAAkB;EAClB;IACE;oCACgC;EAClC;EACA;IACE,gGAAgG;EAClG;EACA,yBAAyB;EACzB;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,2CAA2C;EAC7C;EACA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;EACA,uBAAuB;EACvB;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA,mBAAmB;EACnB;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;EAC1C;EACA;IACE,kBAAkB;EACpB;EACA,oBAAoB;EACpB;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA,kBAAkB;EAClB;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oCAAoC;EACtC;EACA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,aAAa;EACf;EACA,iBAAiB;EACjB;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Zen+Dots&display=swap\");\n@layer theme, base, components, utilities;\n@layer theme {\n  .grey,\n  .cream {\n    color: #5a1aa8;\n  }\n  .cream-95 {\n    color: #085fc3;\n  }\n  .blue {\n    color: rgb(252, 216, 73);\n  }\n  .error-color {\n    color: #911915;\n  }\n}\n@layer base {\n  :root {\n    line-height: 1.5;\n  }\n  h1 {\n    margin: 0;\n    white-space: nowrap;\n  }\n  h2,\n  h3,\n  h4,\n  h5,\n  ol,\n  ul,\n  figure,\n  p,\n  body {\n    margin: 0;\n  }\n  ol[role=\"list\"],\n  ul[role=\"list\"] {\n    list-style: none;\n    padding-inline: 0;\n  }\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  div,\n  a,\n  label,\n  button,\n  input {\n    font-family: \"Zen Dots\", Inter, system-ui, \"Segoe UI\", Roboto, Helvetica,\n      Arial, sans-serif;\n  }\n  h1 {\n    white-space: nowrap;\n  }\n  p {\n    font-family: \"Zen Dots\", Inter, system-ui, \"Segoe UI\", Roboto, Helvetica, Arial,\n      sans-serif;\n  }\n  button {\n    border-style: none;\n    border-radius: 0.4rem;\n    padding: 0.3rem 1rem;\n    background-color: rgba(66, 172, 248, 0.444);\n  }\n  html {\n    width: 100vw;\n    height: 100vh;\n    background-color: #0c0706dd;\n  }\n  body {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: fit-content;\n    overflow-x: auto;\n  }\n  footer {\n  color: white;\n  }\n  /* card styling */\n  .card-square-small {\n    width: 48px;\n    height: 48px;\n  }\n  .card-square-med {\n    width: 64px;\n    height: 64px;\n  }\n  .card-square-large {\n    width: 400px;\n    height: 400px;\n  }\n  .card-rect-hor-large {\n    width: 500px;\n    height: 180px;\n  }\n  /* icon styling */\n  .icon-div-small {\n    width: 26px;\n    height: 26px;\n  }\n  .icon-div-med {\n    width: 40px;\n    height: 40px;\n  }\n  .icon-div-lg {\n    width: 105px;\n    height: 105px;\n  }\n  .icon-div-2xl {\n    width: 128px;\n    height: 128px;\n  }\n  .icon {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n  /* Background Video's Styling */\n  #background-vid {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    object-fit: cover;\n    min-width: 100%;\n    min-height: 100%;\n    max-width: 100%;\n    max-height: 100%;\n    z-index: -5;\n    opacity: 0.75;\n  }\n  header {\n    box-sizing: border-box;\n    margin: 1.5rem 5%;\n    margin-bottom: 7rem;\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n    min-width: 500px;\n  }\n  /* Searchbar's Styling */\n  #searchbar {\n    flex: 1 0 510px;\n    width: 540px;\n    padding: 0.4rem 0.6rem;\n    margin-bottom: 0.6rem;\n  }\n  #location-input {\n    flex: 1;\n    padding: 0rem 0.5rem;\n    font-size: var(--text-sm);\n    color: #fff7e0;\n  }\n  #location-input::placeholder {\n    color: #fff7e092;\n  }\n  #content {\n    margin: 0rem 5%;\n    margin-top: 4rem;\n    padding-bottom: 1rem;\n    width: 960px;\n    display: grid;\n    grid-template-rows: repeat(5, 215px);\n    grid-template-columns: repeat(4, 1fr);\n    column-gap: 2rem;\n    row-gap: 2rem;\n  }\n  #curr-data {\n    max-width: 900px;\n    min-width: 500px;\n    grid-column: 1 / 5;\n    grid-row: 1 / 2;\n  }\n  #curr-temp {\n    min-width: 300px;\n  }\n  #days-data {\n    grid-column: 1 / 3;\n    grid-row: 3 / 6;\n  }\n  #day-data-cards {\n    flex: auto;\n  }\n  #hours-data {\n    backdrop-filter: blur(25px);\n    background-color: rgba(84, 159, 206, 0.167); \n    border-radius: 0.4rem;\n    border-radius: 0.4rem;\n    padding: 0.5rem 1rem;\n    grid-column: 1 / 5;\n    grid-row: 2 / 3;\n  }\n  #hours-data-cards::-webkit-scrollbar {\n    height: 12px;\n  }\n  #hours-data-cards::-webkit-scrollbar-track {\n    background: rgba(255, 255, 255, 0.1);\n  }\n  #hours-data-cards::-webkit-scrollbar-thumb {\n    background: #2572ca;\n    border-radius: 6px;\n  }\n  #hours-data-cards::-webkit-scrollbar-button {\n    background: #2572ca;\n    width: 12px;\n    height: 12px;\n  }\n  #curr-humidity-data {\n    grid-column: 3 / 4;\n    grid-row: 3 / 4;\n  }\n  #curr-precipitation-data {\n    grid-column: 4 / 5;\n    grid-row: 3 / 4;\n  }\n  #curr-wind-data {\n    grid-column: 3 / 5;\n    grid-row: 4 / 5;\n  }\n  #curr-uv-data {\n    grid-column: 3 / 4;\n    grid-row: 5 / 6;\n  }\n  #curr-pressure-data {\n    grid-column: 4 / 5;\n    grid-row: 5 / 6;\n  }\n  #compass {\n    position: relative;\n  }\n  #compass-base {\n    position: relative;\n    background-image: url(\"../assets/icons/utility/compass_base.png\");\n    background-position: center;\n    background-size: cover;\n    width: 140px;\n    height: 140px;\n    filter: invert(20%) sepia(100%) saturate(10000%) hue-rotate(35deg) brightness(100%) contrast(100%);\n  }\n  #compass-needle {\n    position: absolute;\n    background-image: url(\"../assets/icons/utility/arrow.png\");\n    background-position: center;\n    background-size: cover;\n    width: 140px;\n    height: 140px;\n    filter: invert(20%) sepia(100%) saturate(10000%) hue-rotate(35deg) brightness(100%) contrast(100%);\n  }\n}\n@layer components {\n  .weather-card {\n    backdrop-filter: blur(25px);\n    background-color: rgba(84, 159, 206, 0.167); \n    border-radius: 1rem;\n    padding: 0.5rem 1rem;\n    padding-bottom: 1rem;\n  }\n  .hour-component {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    height: 124px;\n    margin: 0.8rem;\n  }\n  .day-component {\n    margin: 0.6rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .temp-bar {\n    position: relative;\n    flex: initial;\n    height: 0.5rem;\n    min-width: 130px;\n    background-color: #6e6e6e65;\n    border-radius: 0.2rem;\n  }\n  .temp-bar > .bar {\n    position: absolute;\n    z-index: 2;\n    left: 0;\n    width: 100%;\n    border-radius: 1rem;\n    height: 100%;\n    background-image: linear-gradient(to right, #5ef11f, #fdde29);\n  }\n  .wind-text-wrapper {\n    display: flex;\n    justify-content: space-between;\n  }\n}\n@layer utilities {\n  .width-42px {\n    width: 42px;\n  }\n  .width-55px {\n    width: 55px;\n  }\n  /* SVG's Styling */\n  .cream-svg {\n    filter: invert(89%) sepia(5%) saturate(800%) hue-rotate(365deg)\n      brightness(120%) contrast(95%);\n  }\n  .red-svg {\n    filter: invert(35%) sepia(100%) saturate(2500%) hue-rotate(0deg) brightness(100%) contrast(100%);\n  }\n  /* Background's Styling */\n  .no-background {\n    background: none;\n  }\n  .background-frosted {\n    backdrop-filter: blur(15px);\n    background-color: rgba(240, 240, 240, 0.15);\n  }\n  .background-frosted-grey {\n    backdrop-filter: blur(25px);\n    background-color: rgba(65, 65, 65, 0.359);\n  }\n  /* Overflow Behaviour */\n  .overflow-x-scroll {\n    overflow-x: scroll;\n  }\n  .overflow-y-scroll {\n    overflow-y: scroll;\n  }\n  .overflow-x-auto {\n    overflow-x: auto;\n  }\n  .overflow-y-auto {\n    overflow-y: auto;\n  }\n  /* border styling */\n  .border-rounded {\n    border-radius: 0.8rem;\n  }\n  .border-white-outline {\n    border-style: solid;\n    border-width: 0.8px;\n    border-color: rgba(255, 255, 255, 0.391);\n  }\n  .no-border {\n    border-style: none;\n  }\n  /* display styling */\n  .width-60pc {\n    width: 60%;\n  }\n  .height-36px {\n    height: 36px;\n  }\n  .height-80px {\n    height: 80px;\n  }\n  .grid {\n    display: grid;\n  }\n  .flex {\n    display: flex;\n  }\n  .flex-col {\n    display: flex;\n    flex-direction: column;\n  }\n  .flex-auto {\n    flex: auto;\n  }\n  .inline-block {\n    display: inline-block;\n  }\n  .hidden {\n    display: none;\n  }\n  .justify-center {\n    justify-content: center;\n  }\n  .space-btw {\n    justify-content: space-between;\n  }\n  .space-evenly {\n    justify-content: space-evenly;\n  }\n  .align-start {\n    align-items: flex-start;\n  }\n  .align-center {\n    align-items: center;\n  }\n  .align-bottom {\n    align-items: end;\n  }\n  .gap-0p2 {\n    gap: 0.2rem;\n  }\n  .gap-0p4 {\n    gap: 0.4rem;\n  }\n  .gap-0p6 {\n    gap: 0.6rem;\n  }\n  .gap-1p5 {\n    gap: 1.5rem;\n  }\n  .gap-1 {\n    gap: 1rem;\n  }\n  .gap-2 {\n    gap: 2rem;\n  }\n  .gap-4 {\n    gap: 4rem;\n  }\n  /* Box's Styling */\n  .margin-tb-1 {\n    margin: 1rem 0rem;\n  }\n  .margin-right-auto {\n    margin-right: auto;\n  }\n  .margin-left-auto {\n    margin-left: auto;\n  }\n  .margin-top-auto {\n    margin-top: auto;\n  }\n  .margin-bot-auto {\n    margin-bottom: auto;\n  }\n  .margin-left-3 {\n    margin-left: 3rem;\n  }\n  .margin-left-05 {\n    margin-left: 0.5rem;\n  }\n  .margin-bot-1p2 {\n    margin-bottom: 1.2rem;\n  }\n  .margin-bot-2 {\n    margin-bottom: 2rem;\n  }\n  .margin-bot-12 {\n    margin-bottom: 12rem;\n  }\n  .padding-2 {\n    padding: 2rem;\n  }\n  .padding-bot-0p2 {\n    padding-bottom: 0.2rem;\n  }\n  .border-bot-outline {\n    border-bottom: 0.8px solid #fff9e895;\n  }\n  /* Pseudoclass Styling */\n  .no-focus:focus {\n    border-style: none;\n    outline: none;\n  }\n  /* Text Styling */\n  .text-center {\n    text-align: center;\n  }\n  .text-sm {\n    font-size: 0.9rem;\n  }\n  .text-base {\n    font-size: 1rem;\n  }\n  .text-med {\n    font-size: 1.25rem;\n  }\n  .text-lg {\n    font-size: 1.5rem;\n  }\n  .text-2xl {\n    font-size: 2rem;\n  }\n  .text-3xl {\n    font-size: 3rem;\n  }\n  .text-4xl {\n    font-size: 4rem;\n  }\n  .text-5xl {\n    font-size: 5rem;\n  }\n  .text-6xl {\n    font-size: 6rem;\n  }\n  .text-8xl {\n    font-size: 8rem;\n  }\n  .weight-light {\n    font-weight: 200;\n  }\n  .weight-normal {\n    font-weight: 300;\n  }\n  .weight-med {\n    font-weight: 500;\n  }\n  .weight-semibold {\n    font-weight: 600;\n  }\n  .weight-bold {\n    font-weight: 700;\n  }\n  .letter-space-05 {\n    letter-spacing: -0.5px;\n  }\n  .line-height-1 {\n    line-height: 1;\n  }\n  .line-height-1p2 {\n    line-height: 1.2;\n  }\n  .line-height-1p5 {\n    line-height: 1.5;\n  }\n  .line-height-2 {\n    line-height: 2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
